import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Output,
  ViewEncapsulation,
} from '@angular/core';

export interface SgAsyncContainerAfterAsyncEvent<T = any, C = any> {
  result?: T;
  context?: C;
  error?: Error;
  keep(): void;
}

@Component({
  selector: 'sg-async-container',
  templateUrl: './async-container.component.html',
  styleUrls: ['./async-container.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SgAsyncContainerComponent {
  @Output() beforeAsync = new EventEmitter<void>();
  @Output() afterAsync = new EventEmitter<SgAsyncContainerAfterAsyncEvent>();
  showAwaitContent = false;

  constructor(private cdRef: ChangeDetectorRef) {}

  startAsync(asyncOp: Promise<any>, context?: any): void {
    this.beforeAsync.next();
    this.showAwaitContent = true;
    let keepAwaiting = false;
    const keep = () => (keepAwaiting = true);
    this.cdRef.detectChanges();
    asyncOp
      .then((result) => this.afterAsync.next({ result, context, keep }))
      .catch((error) => {
        try {
          this.afterAsync.next({ error, context, keep });
        } catch (err) {}
      })
      .then(() => {
        this.showAwaitContent = keepAwaiting;
        this.cdRef.detectChanges();
      });
  }
}
